import loadable from '@loadable/component';

export const LoadableCompareDrawer = loadable(() => import(/* webpackChunkName: "compare-drawer" */ './compare-drawer.component'), {
	resolveComponent: ({ CompareDrawer }) => CompareDrawer
});
